<template>
  <div class='box'>
    <!-- Header -->
    <div class="tags has-addons">
      <span class="tag" :class='!this.showBoss ? "is-dark" : "" ' style='width: 125px; cursor: pointer' v-on:click='switchSection(false)'>Colaborador</span>
      <span class="tag" :class='this.showBoss ? "is-dark" : "" ' style='width: 125px; cursor: pointer' v-on:click='switchSection(true)'>Líder</span>
    </div>

    <!-- Content -->
    <div class='contentMessages'>
      <!-- Collaborator -->
      <div v-if='!showBoss' style='width: 100%; margin-right: 10px'>
        <div class='is-flex'>
          <input v-model='data.colaboradorEmail.emailSubject' :class='errors.colaboradorEmail.emailSubject.type' style='margin-right: 5px;' class="input" type="text" placeholder="Asunto" name='subjectCo' id='subjectCo'>
          <!-- Dropdown -->
          <div class="dropdown" :class='!showBoss && dropdownTools ? "is-active" : ""'>
            <div class="dropdown-trigger" tabindex='0' v-on:focusout='onFocusDropDown()'>
              <button class='button is-dark' aria-haspopup="true" aria-controls="dropdown-menu-toolsEmail" v-on:click='switchDropdown()'>
                <i class='material-icons' style='margin: auto'>build</i>
              </button>
            </div>
            <div class="dropdown-menu" id="dropdown-menu3" role="menu">
              <div class="dropdown-content">
                <a href="javascript:void(0)" v-on:click='actionsOfDropdown("link")' class="dropdown-item">
                  Link de encuesta
                </a>
                <a href="#" class="dropdown-item" v-on:click='actionsOfDropdown("nameClient")'>
                  Nombre de empresa
                </a>
              </div>
            </div>
          </div>
        </div>
        <span v-if='errors.colaboradorEmail.emailSubject.message' class='is-size-7 has-text-danger' style='margin-top: -5px'>{{errors.colaboradorEmail.emailSubject.message}}</span>
        <br><br>
        <textarea v-model='data.colaboradorEmail.emailCuerpo' :class='errors.colaboradorEmail.emailCuerpo.type' class="textarea textareaSettings" ref='emailCuerpoCol' placeholder="Cuerpo del mensaje... Clic derecho para mas opciones" rows="20" name='cuerpoCo' id='cuerpoCo'></textarea>
        <span v-if='errors.colaboradorEmail.emailCuerpo.message' class='is-size-7 has-text-danger' style='margin-top: -5px'>{{errors.colaboradorEmail.emailCuerpo.message}}</span>
      </div>
      <div v-if='!showBoss' style='width: 100%; margin-left: 10px'>
        <article class="message is-dark" style='height: 100%'>
          <div class="message-body" style='height: 100%'>
            <h1 class='is-size-3'>Líder PHD Evaluación del líder</h1>
            <h2 class="is-size-5">Hola {{ tokenUser.name }}</h2>
            <br>
            <p style="white-space: pre-line">
              En <span class='has-text-weight-bold'>{{empresa.nombre}}</span> queremos que nuestros y nuestras líderes sean cada vez mejores. Por esto iniciamos la valoración de sus competencias de liderazgo.

              Te pedimos que evalúes a tu jefe. Tardarás entre 20 y 30 minutos. Asegúrate de tener tiempo suficiente y concentrarte solo en esta actividad.

              <span class='has-text-weight-bold'>Ayuda a tu jefe a mejorar aquí.</span>

              Tu participación es muy importante.

              ¡Gracias!


              *Por favor no reenvíes este correo.
              ** Si tienes dificultades comunícate con elena@sietegho.com
            </p>
            <br>
            <span class="tag is-info">Mensaje por defecto</span>
          </div>
        </article>
      </div>
      <!-- Leader -->
      <div v-if='showBoss' style='width: 100%; margin-right: 10px'>
        <div class='is-flex'>
          <input v-model='data.liderEmail.emailSubject' :class='errors.liderEmail.emailSubject.type' style='margin-right: 5px;' class="input" type="text" placeholder="Asunto" name='subjectBoss' id='subjectBoss'>
          <!-- Dropdown -->
          <div class="dropdown" :class='showBoss && dropdownTools ? "is-active" : ""'>
            <div class="dropdown-trigger" tabindex='0' v-on:focusout='switchDropdown'>
              <button class='button is-dark' aria-haspopup="true" aria-controls="dropdown-menu-toolsEmail" v-on:click='switchDropdown()'>
                <i class='material-icons' style='margin: auto'>build</i>
              </button>
            </div>
            <div class="dropdown-menu" id="dropdown-menu3" role="menu">
              <div class="dropdown-content">
                <a href="javascript:void(0)" v-on:click='actionsOfDropdown("link")' class="dropdown-item">
                  Link de encuesta
                </a>
                <a href="javascript:void(0)" class="dropdown-item" v-on:click='actionsOfDropdown("nameClient")'>
                  Nombre de empresa
                </a>
              </div>
            </div>
          </div>
        </div>
        <span v-if='errors.liderEmail.emailSubject.message' class='is-size-7 has-text-danger' style='margin-top: -5px'>{{errors.liderEmail.emailSubject.message}}</span>
        <br><br>
        <textarea v-model='data.liderEmail.emailCuerpo' :class='errors.liderEmail.emailCuerpo.type' class="textarea textareaSettings" ref='emailCuerpoLid' placeholder="Cuerpo del mensaje... Clic derecho para mas opciones" rows="20" name='cuerpoBoss' id='cuerpoBoss'></textarea>
        <span v-if='errors.liderEmail.emailCuerpo.message' class='is-size-7 has-text-danger' style='margin-top: -5px'>{{errors.liderEmail.emailCuerpo.message}}</span>
      </div>
      <div v-if='showBoss' style='width: 100%; margin-left: 10px'>
        <article class="message is-dark" style='height: 100%'>
          <div class="message-body" style='height: 100%'>
            <h1 class='is-size-3'>Líder PHD Autoevaluación</h1>
            <h2 class="is-size-5">Hola {{ tokenUser.name }}</h2>
            <br>
            <p style="white-space: pre-line">
              En <span class='has-text-weight-bold'>{{empresa.nombre}}</span> queremos que nuestros y nuestras líderes sean cada vez mejores. Por esto, iniciamos la valoración de tus competencias de liderazgo.

              Te pedimos que hagas tu autoevaluación. Tardarás entre 20 y 30 minutos. Asegúrate de tener tiempo suficiente y concentrarte solo en esta actividad.

              <span class='has-text-weight-bold'>Evalúate aquí.</span>

              Tu participación es muy importante.

              ¡Gracias!


              *Por favor no reenvíes este correo.
              ** Si tienes dificultades comunícate con elena@sietegho.com
            </p>
            <br>
            <span class="tag is-info">Mensaje por defecto</span>
          </div>
        </article>
      </div>
    </div>

    <!-- Footer -->
    <div class='buttons' style='margin-top: 10px'>
      <a class="button is-danger" v-on:click='deleteMessage()'>Eliminar</a>
      <button class="button is-dark" :class='loading ? "is-loading" : ""' v-on:click='saveData'>Guardar</button>
    </div>
  </div>
</template>
<script>
import apiServices from "@/services/yungol-services";
import {mapState} from 'vuex'
export default {
  data(){
    return {
      showBoss: false,
      errors: {
        liderEmail:{
          emailSubject: {},
          emailCuerpo: {}
        },
        colaboradorEmail:{
          emailSubject: {},
          emailCuerpo: {}
        }
      },
      loading: false,
      dropdownTools: false,
    }
  },
  props:{
    proceso: Object,
    data: Object,
    tokenUser: Object
  },
  computed:{
    ...mapState(["empresa"])
  },
  methods:{
    switchSection(d){
      this.showBoss = d
      this.clearErrors()
    },
    async saveData() {
      if (this.validateForm()) {
        try {
          this.loading = true
          const result = await apiServices.post(`createinfo/${this.proceso._id}`, this.data);

          if (result.data){
            await this.$swal({
              text: 'Se guardo correctamente el mensaje.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1700
            })
            this.loading = false
            this.clearErrors()
          }
        } catch (error) {
          console.log(error)
          await this.$swal({
            text: 'Error al guardar el mensaje.',
            icon: 'error',
            showConfirmButton: false,
            timer: 1700
          })
          this.loading = false
          this.clearErrors()
        }
      }
    },
    async deleteMessage() {
      const config = {
        title: '¿Estás seguro?',
        text: "Al eliminar no se podrá recuperar el mensaje personalizado.",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#de5b5b',
        confirmButtonText: 'Sí, eliminar'
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.clearErrors()
            const data = {
              liderEmail: {
                emailSubject: '',
                emailCuerpo: ''
              },
              colaboradorEmail: {
                emailSubject: '',
                emailCuerpo: ''
              }
            }
            const type = this.showBoss ? 'liderEmail' : 'colaboradorEmail'
            const resultData = await apiServices.post(`createinfo/${this.proceso._id}`, data[type]);
            if (resultData) {
              this.$emit('getData')
              await this.$swal({
                text: 'Mensaje personalizado eliminado correctamente.',
                icon: 'success',
                showConfirmButton: false,
                timer: 1700
              })
            }
          } catch (err) {
            await this.$swal({
              text: 'Error al eliminar el mensaje personalizado.',
              icon: 'error',
              showConfirmButton: false,
              timer: 1700
            })
            console.log(err)
          }
        }
      });
    },
    // Dropdown
    switchDropdown(){
      this.dropdownTools = !this.dropdownTools
    },
    actionsOfDropdown(type){
      const typeEmail = this.showBoss ? 'liderEmail' : 'colaboradorEmail'

      if (type === 'nameClient'){
        this.data[typeEmail].emailCuerpo += "[NOMBRE_EMPRESA]"
      }
      if (type === 'link'){
        this.data[typeEmail].emailCuerpo += "<a>Contenido del link</a>"
      }
    },
    onFocusDropDown(){
      setTimeout(() => {
        this.switchDropdown();
      }, 100)
    },
    // ContexMenuTextArea Custom
    showContextMenu(event) {
      // Evita que aparezca el menú contextual del navegador
      event.preventDefault();
      const exist = document.getElementById('contexMenuCustom')
      if (exist){
        exist.remove()
      }

      // Crea un elemento de menú contextual personalizado
      const customMenu = document.createElement("div");
      customMenu.className = "box";
      customMenu.id = "contexMenuCustom";
      customMenu.innerHTML = `
          <a href="javascript:void(0)" class="dropdown-item" data-item="nameClient">Nombre de empresa</a>
          <a href="javascript:void(0)" class="dropdown-item" data-item="link">Link</a>
      `;

      // Posiciona el menú contextual en la posición del clic derecho
      customMenu.style.position = "absolute";
      customMenu.style.left = (event.clientX + window.scrollX) + 'px';
      customMenu.style.top = (event.clientY + window.scrollY) + 'px';

      // Agrega el menú al cuerpo del documento
      document.body.appendChild(customMenu);

      // Agrega un evento clic al menú para manejar las acciones de los elementos
      customMenu.addEventListener("click", (e) => {
        const selectedItem = e.target.getAttribute("data-item");
        if (selectedItem) {
          this.handleMenuItemClick(selectedItem);
        }
        // Elimina el menú contextual personalizado después de hacer clic
        const ctx = document.getElementById('contexMenuCustom')
        if (ctx){
          ctx.remove()
        }
      });

      // Agrega un evento de clic en el documento para cerrar el menú si se hace clic en cualquier otro lugar
      document.addEventListener("click", () => {
        const ctx = document.getElementById('contexMenuCustom')
        if (ctx){
          ctx.remove()
        }
      });
    },
    handleMenuItemClick(item) {
      // Maneja las acciones de los elementos del menú aquí
      const textarea = this.showBoss ? this.$refs.emailCuerpoLid : this.$refs.emailCuerpoCol;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      // Obtiene el valor del item
      let valueItem = ""
      if (item === "nameClient"){
        valueItem = "[NOMBRE_EMPRESA]"
      }
      if (item === "link"){
        valueItem = "<a>Contenido del link</a>"
      }

      // Obtiene el contenido del textarea
      const content = textarea.value;

      // Inserta el valor del elemento del menú en la posición actual del cursor
      const newText = content.substring(0, start) + valueItem + content.substring(end);

      // Actualiza el contenido del textarea
      textarea.value = newText;

      // Restablece la selección después de la inserción
      textarea.setSelectionRange(start + item.length, start + item.length);
    },
    // Helpers
    validateForm(){
    this.errors = {
      liderEmail:{
        emailSubject: {},
        emailCuerpo: {}
      },
      colaboradorEmail:{
        emailSubject: {},
        emailCuerpo: {}
      }
    }

    const data = this.data
    const type = this.showBoss ? 'liderEmail' : 'colaboradorEmail'
    let valid = true

    if (data[type].emailSubject.trim() === '' || data[type].emailSubject === null || data[type].emailSubject === undefined){
      this.errors[type].emailSubject.type = 'is-danger'
      this.errors[type].emailSubject.message = 'El asunto es requerido.'
      valid = false
    }

    if (data[type].emailCuerpo.trim() === '' || data[type].emailCuerpo === null || data[type].emailCuerpo === undefined){
      this.errors[type].emailCuerpo.type = 'is-danger'
      this.errors[type].emailCuerpo.message = 'El cuerpo es requerido.'
      valid = false
    }

    return valid
  },
    clearErrors(){
      this.errors = {
        liderEmail:{
          emailSubject: {},
          emailCuerpo: {}
        },
        colaboradorEmail:{
          emailSubject: {},
          emailCuerpo: {}
        }
      }
    },
  },
  created() {
    setTimeout(()=>{
      // Agrega un evento de clic derecho al textarea
      this.$refs.emailCuerpoCol.addEventListener("contextmenu", this.showContextMenu);
    },200)
  },
  destroyed() {
    // Eliminar el escuchador de eventos cuando se destruye la instancia de Vue
    document.removeEventListener('click', this.handleClickCloseDropdown);
  },
  watch:{
    showBoss(nv){
      if (nv){
        setTimeout(()=>{
          const textAreaLid = this.$refs.emailCuerpoLid
          if (!textAreaLid.contextmenu){
            this.$refs.emailCuerpoLid.addEventListener("contextmenu", this.showContextMenu);
          }
        },200)
      }
    }
  }
}
</script>
<style lang='scss'>
.contentMessages {
  @media screen and (min-width: 1024px) {
    display: flex;
    justify-content: space-between
  }
}
.message {
  @media screen and (max-width: 1024px){
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/Ajustes/MessageEmailSurvey.vue